import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ButtonProps } from "./Button";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { resetfilter } from "../../../common/video/VideoFilterActions";
import { resetUserfilter } from "../../../presenters/UserFilterActions";
import clsx from "clsx";
import stylesPc from "./NavButton.module.css";
import stylesSp from "./NavButton_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
interface NavButtonProps extends ButtonProps {
    path: string;
}
function HeaderButton({ children, path, icon, ...otherProps }: NavButtonProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const history = useHistory();
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const isActive =
        path === pathname ||
        (path === "/videos" && pathname.match(/^\/video/)) ||
        (path === "/slides" && pathname.match(/^\/slidestock/)) ||
        (path === "/studio/timelineTop" && pathname.match(/^\/studio\/editTimeline/))
            ? true
            : false;

    const handleClick = useCallback(
        (e) => {
            if (!isActive || pathname.match(/^\/video\/|^\/slidestock\/|^\/studio\/editTimeline/)) {
                dispatch(
                    resetfilter({ id: [], professional: [], program: [], project: [], tag: [] })
                );
                dispatch(resetUserfilter({ id: -1, skill: [], tag: [] }));
                history.push(path);
                if (otherProps.onClick) {
                    otherProps.onClick(e);
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [dispatch, history, otherProps, path, isActive, pathname]
    );
    const classes = clsx({
        [styles.buttonActive]: isActive,
        [styles.buttonWhite]: true,
    });
    return (
        <motion.div>
            <button
                className={classes}
                onClick={handleClick}
                {...otherProps}
                style={{ cursor: pathname.startsWith("/video/") ? "pointer" : "" }}
            >
                <div className={`${styles.content} ${isActive ? styles.isActive : ""}`}>
                    {icon && icon}

                    {children && <div className={styles.label}>{children}</div>}
                </div>
            </button>
        </motion.div>
    );
}
export default HeaderButton;
